export default "__VITE_ASSET__Ck43f7$x__"